//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-attach",
  props:['sourceDto','defaultPar','isSupplier'],
  methods:{
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-attach.vue